import React from "react";

const NumberAndTextShow = React.memo(({ bigtext, smalltext, nextrowtext }) => {
  return (
    <div>
      <div
        style={{
          fontFamily: "nohemi-bold",
          fontSize: "4.5rem",
          fontWeight: "400",
          lineHeight: "5rem",
          letterSpacing: "5px",
          textAlign: "center",
          color: "#ffffff",
        }}
      >
        {bigtext}
        <span
          style={{
            fontSize: "3.2rem",
            lineHeight: "4rem",
            letterSpacing: "2.6px",
            textAlign: "center",
            color: "rgba(255, 255, 255, 0.5)",
          }}
        >
          {smalltext}
        </span>
      </div>
      <div
        style={{
          fontFamily: "sans-serif",
          color: "rgba(255, 255, 255, 0.7)",
          fontWeight: "400",
          fontSize: "1.6rem",
          lineHeight: "2rem",
          letterSpacing: "0.78px",
          textAlign: "center",
        }}
      >
        {nextrowtext}
      </div>
    </div>
  );
});

export default NumberAndTextShow;
